import React from 'react'

export default function Receipt() {
  return (
    <div>Receipt</div>
  )
}
